"use client";

import Link from "next/link";
import { useTreatmentHref } from "@/hooks/useTreatmentHref";

interface TreatmentLinkProps extends Omit<React.ComponentProps<typeof Link>, "href"> {
  slug: string;
  parentSlug?: string;
  cityName?: string | null;
}

/**
 * Link that uses city-prefixed href when cityName or useResolvedCity returns a valid city.
 * Prefetches by default; callers can opt out with `prefetch={false}`.
 */
export function TreatmentLink({ slug, parentSlug, cityName, prefetch = true, ...rest }: TreatmentLinkProps) {
  const href = useTreatmentHref(slug, parentSlug, cityName);
  return <Link href={href} prefetch={prefetch} {...rest}/>;
}
